var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.999,
    height: 21.999,
    viewBox: "0 0 21.999 21.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-523.295 -1765.414)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 358",
    d: "M534.294 1765.414a11 11 0 1 0 11 11 11.012 11.012 0 0 0-11-11zm0 20.263a9.263 9.263 0 1 1 9.263-9.263 9.273 9.273 0 0 1-9.263 9.263z",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 359",
    d: "M536.4 1772.222a3.7 3.7 0 0 0-3.7 3.7.541.541 0 0 0 1.081 0 2.617 2.617 0 0 1 2.617-2.62 2.617 2.617 0 0 1 2.614 2.62 2.954 2.954 0 0 1-1.89 2.49 1.9 1.9 0 0 0-1.268 1.787v.911a.54.54 0 1 0 1.08 0v-.911a.815.815 0 0 1 .543-.767 4.008 4.008 0 0 0 2.615-3.51 3.7 3.7 0 0 0-3.692-3.7z",
    transform: "translate(-2.11 -1.527)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 0.593,
    cy: 0.593,
    r: 0.593,
    transform: "translate(533.702 1780.938)",
    style: {
      fill: "#254089"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.649e94e391af84f8a2a2f185b099f87b.svg";
export { ForwardRef as ReactComponent };